export default "__VITE_ASSET__Dfvpm6xp__"